import React from 'react'
import { OnboardingStep } from '../types/onboardingTypes'
import StepSubtitle from './StepSubtitle.component'
import StepTitle from './StepTitle.component'

interface InfoStepProps {
  stepConfig: OnboardingStep
}

const InfoStep: React.FC<InfoStepProps> = ({ stepConfig }) => {
  return (
    <div>
      <StepTitle>{stepConfig.wordings!.title}</StepTitle>
      <StepSubtitle>{stepConfig.wordings!.subtitle}</StepSubtitle>
    </div>
  )
}

export default InfoStep
